 <!-- Dynamic Menu -->
<ul class="layout-menu" *ngIf="model$ | async as model">
  <ng-container *ngFor="let item of model; let i = index">
    <app-menuitem 
      [item]="item" 
      [index]="i" 
      [root]="true">
    </app-menuitem>
    @if(i < model.length - 1){
      <li>
          <p-divider></p-divider>
      </li>
    }
  </ng-container>
</ul>
  